import { useQuery, useMutation, useQueryClient } from 'react-query';
import { Link } from 'react-router-dom';
import api from '../../utils/api';
import { Heart, MapPin, Star } from 'lucide-react';

export default function FavoritesPage() {
  const queryClient = useQueryClient();

  const { data, isLoading } = useQuery('favorites', () =>
    api.get('/favorites').then(r => r.data)
  );

  const removeMutation = useMutation(
    (listingId) => api.post(`/favorites/${listingId}`),
    { onSuccess: () => queryClient.invalidateQueries('favorites') }
  );

  const favorites = data?.favorites || [];

  return (
    <div className="space-y-6" dir="rtl">
      <div>
        <h1 className="text-2xl font-bold text-white">المفضلة</h1>
        <p className="text-slate-400 mt-1">{favorites.length} إعلان محفوظ</p>
      </div>

      {isLoading ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {[1,2,3].map(i => <div key={i} className="skeleton h-64 rounded-2xl" />)}
        </div>
      ) : favorites.length === 0 ? (
        <div className="glass rounded-2xl p-16 text-center">
          <Heart size={48} className="text-slate-600 mx-auto mb-4" />
          <h3 className="text-xl font-bold text-white mb-2">قائمة المفضلة فارغة</h3>
          <p className="text-slate-400 mb-6">احفظ الإعلانات التي تعجبك لتجدها هنا بسهولة</p>
          <Link to="/listings" className="btn-primary">تصفح الإعلانات</Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {favorites.map(item => (
            <div key={item.id} className="glass rounded-2xl overflow-hidden hover:border-primary-500/30 transition-colors group">
              <div className="relative aspect-video">
                {item.primary_image ? (
                  <img src={`${process.env.REACT_APP_API_URL}/${item.primary_image}`} alt={item.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
                ) : (
                  <div className="w-full h-full bg-slate-700 flex items-center justify-center">
                    <Heart size={32} className="text-slate-500" />
                  </div>
                )}
                <button
                  onClick={() => removeMutation.mutate(item.listing_id)}
                  className="absolute top-2 left-2 w-8 h-8 bg-red-500 rounded-full flex items-center justify-center hover:bg-red-600 transition-colors"
                >
                  <Heart size={14} className="text-white fill-white" />
                </button>
              </div>
              <div className="p-4">
                <h3 className="font-bold text-white mb-1 line-clamp-1">{item.title}</h3>
                <div className="flex items-center justify-between text-sm text-slate-400">
                  <span className="flex items-center gap-1"><MapPin size={12} />{item.city}</span>
                  <span className="flex items-center gap-1"><Star size={12} className="text-amber-400" />{item.avg_rating ? Number(item.avg_rating).toFixed(1) : '—'}</span>
                </div>
                <div className="flex items-center justify-between mt-3">
                  <span className="text-primary-400 font-bold">{item.price_per_hour} {item.currency}/ساعة</span>
                  <Link to={`/listings/${item.listing_uuid}`} className="text-xs text-primary-400 hover:text-primary-300">
                    عرض التفاصيل ←
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
